import { handleMutationResponse } from "@/react/services/api/handleMutationResponse";
import { KEY } from "@/react/components/table/useTableMutations";

import schema from "./schema";

const handleUpdateResponse = ({ rowsToUpdate, setRowsToUpdate, setData }) => {
  return handleMutationResponse({
    rows: rowsToUpdate,
    setRows: setRowsToUpdate,
    setData,
    responseMappingKey: schema.fields.id.spec.key,
    idKey: KEY,
    notifyContent: (successfulMutationCount, mutationCount) =>
      `${successfulMutationCount}/${mutationCount} agent${
        mutationCount === 1 ? "" : "s"
      } updated`,
  });
};

export default handleUpdateResponse;
